<div
  *ngIf="displayLicense"
  [ngSwitch]="displayLicense.is_display_link"
  class="text-center u-mt1 u-mb1 qa-list-license"
>
  <a
    *ngSwitchCase="true"
    [href]="displayLicense.id"
    class="qa-list-license-link"
  >
    {{ displayLicense.title }}
  </a>

  <ng-container *ngSwitchDefault>
    {{ displayLicense.title }}
  </ng-container>
</div>
